import { Box, Typography } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";

// Count frequency of values
const countMap = (arr) =>
  Object.entries(
    arr.reduce((acc, v) => {
      acc[v] = (acc[v] || 0) + 1;
      return acc;
    }, {})
  ).map(([key, count]) => ({ key, count }));

export default function TabMiniCharts({ companies }) {
  if (!companies || companies.length === 0) return null;

  // ------------------------------
  // INDUSTRY (BUCKETS)
  // ------------------------------
  const industryData = countMap(
    companies.flatMap((c) => c.BucketIndustries || [])
  );

  // ------------------------------
  // COUNTRIES
  // ------------------------------
  const countryData = countMap(
    companies.map((c) => c["Headquarters Location"] || "Unknown")
  );

  // ------------------------------
  // FUNDING STAGE
  // ------------------------------
  const stageData = countMap(
    companies.map((c) => c["Investment Stage"] || "Unknown")
  );

  // ------------------------------
  // Render helper
  // ------------------------------
  const renderChart = (title, data, color, angle = 0) => {
    if (!data || data.length === 0) return null;

    return (
      <>
        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={230}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis
              dataKey="key"
              angle={angle}
              textAnchor={angle === 0 ? "middle" : "end"}
              height={angle === -90 ? 110 : 50}   // extra height only for -90°
              interval={0}
            />

            <YAxis allowDecimals={false} />

            <Tooltip />
            <Legend />

            <Bar dataKey="count" fill={color} />
          </BarChart>
        </ResponsiveContainer>
      </>
    );
  };

  return (
    <Box sx={{ mb: 4 }}>
      {renderChart("Industry Distribution", industryData, "#1976d2", 0)}        {/* Horizontal */}
      {renderChart("Country Distribution", countryData, "#4caf50", -90)}       {/* Vertical */}
      {renderChart("Investment Stage Distribution", stageData, "#9c27b0", 0)}  {/* Horizontal */}
    </Box>
  );
}
